import { http } from 'src/config';
import { URLSVC } from 'src/config/helper/urlService';
import Swal from 'sweetalert2'
import { loadingBar } from '../globalAction';

export const setBeritas = () => {
    return (dispatch) => {
        http.get(`${URLSVC}/app/user/GetAppNews`).then((res) => {
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({type: 'DATA_BERITAS', payload: data.Data})
            } else {
                dispatch({type: 'DATA_BERITAS', payload: data.Data})
                //Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setBerita = (Id) => {
    return (dispatch) => {
        loadingBar(true);
        dispatch({type: 'RESET_FORM_BERITA'})
        var Url = `${URLSVC}/app/user/GetAppNewsById?Id=${Id}`;
        http.get(Url).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                dispatch({ type: 'DATA_INFOGRAFIS', payload: data.Data })

                dispatch(setFormBerita('Id', data.Data.Id))
                dispatch(setFormBerita('Header', data.Data.Header))
                dispatch(setFormBerita('Title', data.Data.Title))
                dispatch(setFormBerita('Type', data.Data.Type))
                dispatch(setFormBerita('Description', data.Data.Description))
                dispatch(setFormBerita('FileName', data.Data.FileName))

                dispatch({type: 'MODAL_BERITA', payload: true})
                
            } else {
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const setFormBerita = (formType, formValue) => {
    return {type: 'FORM_BERITA', formType, formValue}
}

export const apiAddUpdateBerita = (iData,reset) => {
    return (dispatch) => {
        loadingBar(true);
        var fd = new FormData();
        var URL = ``;
        URL = `${URLSVC}/app/user/SaveAppNews`;
        fd.append('Id', iData.Id);
        fd.append('Header', iData.Header);
        fd.append('Title', iData.Title);
        fd.append('Description', iData.Description);
        fd.append('Type', iData.Type);
        fd.append('FileNameUpload', iData.FileName[0]);
        
        http.post(URL,fd).then((res) => {
            loadingBar(false);
            let data = res.data;
            if (data.IsSuccess) {
                Swal.fire('Berhasil', `berhasil menyimpan berita`, 'success');
                dispatch({ type: 'MODAL_BERITA', payload: false })
                reset();
                dispatch(setBeritas())
            } else {
                dispatch({ type: 'MODAL_BERITA', payload: false })
                Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
            }
        })
    }
}

export const apiActivateBerita = (Id, Title) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan meng-aktifkan data (${Title})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/app/user/SetActiveAppNews`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil meng-aktifkan data (${Title})`, 'success')
                        dispatch(setBeritas())
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}

export const apiDeleteBerita = (Id, Title) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan menghapus data (${Title})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/app/user/DeleteAppNews`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil menghapus data (${Title})`, 'success')
                        dispatch(setBeritas())
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}

export const apiDeActivateBerita = (Id, Title) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan me-nonaktifkan data (${Title})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/app/user/SetNonActiveAppNews`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil me-nonaktifkan data (${Title})`, 'success')
                        dispatch(setBeritas())
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}

export const apiApproveBerita = (Id, Title) => {
    return (dispatch) => {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: `Anda akan menyetujui data (${Title})!`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, saya yakin!'
        }).then((result) => {
            if (result.isConfirmed) {
                var fd = new FormData();
                fd.append('Id', Id);
                http.post(`${URLSVC}/Admins/ApproveBerita`,fd).then((res) => {
                    let data = res.data;
                    if (data.IsSuccess) {
                        Swal.fire('Berhasil', `Anda berhasil menyetujui data (${Title})`, 'success')
                        dispatch(setBeritas())
                    } else {
                        Swal.fire('Gagal', `${data.ReturnMessage}`, 'error')
                    }
                })
            }
        })
    }
}
